import { useEffect, useState } from "react";
import { FlaskConical } from "lucide-react";
import api from "@/lib/api";

export function DemoLogins({ onPick }) {
  const [info, setInfo] = useState(null);
  useEffect(() => { api.get("/demo/info").then((r) => setInfo(r.data)).catch(() => {}); }, []);
  if (!info?.enabled) return null;
  return (
    <div data-testid="demo-logins" className="mt-5 rounded-xl border border-amber-500/30 bg-amber-500/5 px-4 py-3">
      <div className="flex items-center gap-2 text-xs font-semibold text-amber-200"><FlaskConical size={13} /> Demo accounts (no Google needed)</div>
      <p className="text-[11px] text-amber-100/70 mt-1">Click an account to fill the email, then enter the demo password you were given. Data resets daily; payments are simulated.</p>
      <div className="flex flex-wrap gap-1.5 mt-2">
        {info.accounts.map((a) => (
          <button key={a.email} type="button" data-testid={`demo-pick-${a.role.split(" ")[0].toLowerCase()}`} onClick={() => onPick?.(a.email)} className="text-[11px] font-mono px-2 py-1 rounded-md border border-amber-500/30 text-amber-100 hover:bg-amber-500/15">{a.role} · {a.email}</button>
        ))}
      </div>
    </div>
  );
}
